// extracted by mini-css-extract-plugin
export default {"bookContentDesktop":"Books_bookContentDesktop__j31+p"};